import React from 'react';
import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import SectionContact from 'components/SectionContact';

const PlatformPage = ({ path }) => (
  <>
    <Meta title="Privacy Policy" />
    <Layout path={path} lightTheme>
      <section className="privacy-policy">
        <div className="container">
          <h1>
            American Technology Consulting LLC (ATC) WEBSITE PRIVACY POLICY
          </h1>
          <p>
            <span>
              This privacy statement (together with our website Terms of Use and
              any additional data privacy notices on our websites or in targeted
              e-mails) explains how ATC collects and uses the personal data of
              our website visitors, clients and business contacts. Any changes
              we may make to our privacy statement in the future will be posted
              on this page.
            </span>
          </p>
          <p>
            <span>
              If you have any questions now or during your visit, please contact
              us using our contact us form.
            </span>
          </p>
          <p>
            <span>This privacy policy is effective July 1, 2014.</span>
          </p>
          <h2>
            <b>
              We will collect information via Google Analytics about web users,
              but it is not tied to personal identities. We also will collect
              information users provide via calls to action such as their names,
              emails, phone numbers and work skill sets. This information will
              not be remarketed in any way. ATC will use it to contact users and
              engage them via marketing activities.
            </b>
          </h2>
          <p>
            <span>
              ATC will not sell personal data to third parties. We may transfer
              personal data to our contracted service providers and advisors who
              may be located in other countries. Before we do so, we take steps
              to ensure that your personal data will be given adequate
              protection as required by relevant data protection laws and ATC’s
              internal policies.
            </span>
          </p>
          <p>
            <span>
              However, there will be other times when we need to share or
              disclose personal data you provide for a specific purpose, for
              example:
            </span>
          </p>
          <ul>
            <li>
              <span>
                We may need to disclose your personal data to third parties in
                the event that we sell or liquidate any part of our business or
                assets;
              </span>
            </li>
            <li>
              <span>
                We will disclose or share your personal data to comply with any
                legal obligation, or to enforce or apply our Terms of Use; or to
                protect the rights, property, or safety of ATC, our clients, or
                others.
              </span>
            </li>
          </ul>
          <p>
            <span>
              We do not generally seek to collect sensitive personal data
              through this site. In the limited cases where we do seek to
              collect such data, we will do this in accordance with local data
              privacy law requirements. If you choose to provide us with
              unsolicited sensitive personal data, you consent to our using the
              data, subject to applicable law as described in this privacy
              policy. The term “sensitive personal data” refers to the various
              categories of personal data identified by data privacy laws as
              requiring special treatment, including in some circumstances the
              need to obtain explicit consent. These categories may include
              personal identity numbers, financial account information, racial
              or ethnic origin, political opinions, religious, philosophical or
              other similar beliefs, membership in a trade union or profession
              or trade association, physical or mental health, biometric or
              genetic data, sexual life, or criminal record (including
              information about suspected criminal activities).
            </span>
          </p>
          <p>
            <span>
              We take appropriate steps to maintain the security of personal
              data collected via ATC’s websites. You should understand that the
              open nature of the Internet is such that information and personal
              data may flow over networks connecting you to our systems without
              security measures and may be accessed and used by people other
              than those for whom the data is intended.
            </span>
          </p>
          <p>
            <span>
              Our site may, from time to time, contain links to and from the
              sites of our partner networks, advertisers and affiliates. If you
              follow a link to any of these sites, please note that these sites
              have their own privacy policies and that we do not accept any
              responsibility or liability for these policies or sites. Please
              check these policies before you submit any personal data to them.
            </span>
          </p>
          <p>
            <span>
              As a global organization with global IT systems, personal data we
              collect may be routed, stored, or transferred internationally
              throughout ATC’s worldwide organization. We have internal policies
              in place to ensure an equivalent level of protection is in place
              across our organization.
            </span>
          </p>
          <p>
            <span>
              We will retain your personal data while your account is active or
              for as long as needed to provide services to you and, as further
              needed for us to comply with our global legal and contractual
              obligations
            </span>
          </p>
          <h2>
            <b>Your rights</b>
          </h2>
          <p>
            <span>
              You are entitled to know whether we hold personal data about you
              and, if we do, to have access to that personal data and require it
              to be corrected if it is inaccurate. You can do this by using our
              contact us form.
            </span>
          </p>
          <p>
            <span>
              You can exercise the right to discontinue marketing communications
              to you, or to have your personal data removed from our customer
              databases at any time by using our contact usform. In such cases,
              we will retain minimum personal data to note that you opted out in
              order to avoid contacting you again.
            </span>
          </p>
          <p>
            <span>
              If you can’t find what you’re looking for here, or have a concern
              about our use of your personal data, please use the contact us
              form.
            </span>
          </p>
          <h2>
            <b>WEBSITES</b>
          </h2>
          <p>
            <span>This site is administered by ATC</span>
            <b>.</b>
          </p>
          <p>
            <span>
              The primary purpose of our website is to be a resource and
              business tool to help you learn more about us. We want you to feel
              secure when visiting our website and are committed to maintaining
              your privacy when doing so.
            </span>
          </p>
          <h2>
            <b>What information do we gather?</b>
          </h2>
          <p>
            <span>
              ATC collects information at its websites in two ways: (1) directly
              (for example, when you provide information to inquire about a
              Career with ATC); and (2) indirectly (for example, through our
              website’s technology).
            </span>
          </p>
          <p>
            <span>We may collect and process the following information:</span>
          </p>
          <ul>
            <li>
              <span>
                Information that you provide by filling in forms on our website.
                This includes registering to use the website or requesting
                further information. Pages that collect this information may
                provide further information as to why your data is needed and
                how it will be used. It is completely up to you whether you want
                to provide it.
              </span>
            </li>
            <li>
              <span>
                If you contact us, we may keep a record of that correspondence.
              </span>
            </li>
            <li>
              <span>
                We may ask you to complete surveys that we use for research
                purposes, although you do not have to respond to them.
              </span>
            </li>
            <li>
              <span>
                Any postings, comments or other content that you upload or post
                to the ATC website.
              </span>
            </li>
            <li>
              <span>
                Our website collects information about your computer, including
                (where available) your IP address, operating system and browser
                type, for system administration, to filter traffic, to look up
                user domains and to report on statistics.
              </span>
            </li>
            <li>
              <span>
                Details of your visits to our website, the pages you view and
                resources you access or download, including but not limited to,
                traffic data, location data, weblogs and other communication
                data. Please see the cookies section below for more information.
              </span>
            </li>
          </ul>
          <p>
            <span>
              When this information relates to or identifies you, we will treat
              it as “personal data.”
            </span>
          </p>
          <p>
            <span>
              We use personal data to provide you with information you request,
              process online job applications, and for other purposes which we
              would describe to you at the point where it is collected or which
              will be obvious to you. For example:
            </span>
          </p>
          <ul>
            <li>
              <span>To fulfill your requests.</span>
            </li>
            <li>
              <span>For surveys or research questionnaires.</span>
            </li>
            <li>
              <span>To personalize your experience at our website.</span>
            </li>
            <li>
              <span>
                To contact you for marketing purposes where you have agreed to
                this.
              </span>
            </li>
          </ul>
          <p>
            <span>
              We analyze your IP and browser information to determine what is
              most effective about our website, to help us identify ways to
              improve it and make it more effective. Please see the cookies
              section below for more information.
            </span>
          </p>
          <h2>
            <b>COOKIES AND OTHER TRACKING TECHNOLOGIES</b>
          </h2>
          <h2>
            <b>What are cookies?</b>
          </h2>
          <p>
            <span>
              Cookies are text files containing small amounts of information
              which are downloaded to your computer or mobile device when you
              visit a website. Cookies are then sent back to the originating
              website on each subsequent visit, or to another website that
              recognizes that cookie. Cookies are useful because they allow a
              website to recognize a user’s device. You can find more
              information about cookies at: www.allaboutcookies.org.
            </span>
          </p>
          <p>
            <span>
              Cookies do many different jobs, such as letting you navigate
              between pages efficiently, remembering your preferences, and
              generally improving the user experience. They can also help to
              ensure that the advertisements and other content you see online
              are more relevant to you and your interests. They can be set by
              the website that you are visiting (known as first party cookies)
              or by another entity such as an advertising network (known as
              third party cookies).The cookies used on this website have been
              categorized on the basis of the four categories found in the ICC
              UK Cookie guide. A list of all the cookies used on this website by
              category is set out below. Within the four categories, cookies can
              either be session or persistent. Session cookies are temporary and
              once you close the browser window they are deleted from your
              device. Persistent cookies remain on your device for a longer
              period and are used by the website to recognize your device when
              you return.
            </span>
          </p>
          <h2>
            <b>What other tracking technology do we use?</b>
          </h2>
          <p>
            <span>
              We may also use web beacons or other technologies for similar
              purposes and we may include these in marketing e-mail messages to
              determine whether messages have been opened and links clicked on.
              Web beacons do not place information on your device, but may work
              in conjunction with cookies to monitor website activity.
            </span>
          </p>
          <h2>
            <b>What if I don’t want cookies?</b>
          </h2>
          <p>
            <span>
              By using our website you agree that we can place cookies and other
              similar technologies on your device as explained below. If you
              want to remove existing cookies from your device you can do this
              using your browser options. If you want to block future cookies
              being placed on your device you can change your browser settings
              to do this. When you review your browser settings or options, you
              can identify the ATC cookies by the fact they include “.ATC” in
              the name. For more information on managing cookies see
              www.allaboutcookies.org/manage-cookies.
            </span>
          </p>
          <p>
            <span>
              Please bear in mind that deleting and blocking cookies will have
              an impact on your user experience as parts of the website may no
              longer work. Unless you have adjusted your browser settings to
              block cookies, our system will issue cookies as soon as you visit
              our website or click a link in a targeted email we have sent you,
              even if you have previously deleted our cookies.
            </span>
          </p>
          <p>
            <span>
              You cannot remove or block web beacons or personalized URLs, as
              they form part of the content of web pages and emails rather than
              placing information on your device. But, as they work in
              conjunction with cookies, turning off cookies will also prevent
              any web beacons from tracking your user activity on our site. The
              web beacon will still account for an anonymous visit, but your
              unique information will not be recorded.
            </span>
          </p>
          <h2>
            <b>
              What types of cookies are there and which ones does this website
              use?
            </b>
          </h2>
          <p>
            <b>Strictly necessary cookies</b>
            <span>
              {' '}
              – These cookies are essential to enable you to move around the
              site and use its features, such as accessing secure areas of the
              website. Without these cookies, services you have asked for cannot
              be provided.
            </span>
          </p>
          <p>
            <span>
              We categorize the following cookies as strictly necessary:
            </span>
          </p>
          <ol>
            <li>
              <span>
                Registered Visitor Cookie – A unique identifier given to each
                registered user, used to recognize them through their visit and
                when they return to the website (see also Functionality cookies
                below).
              </span>
            </li>
          </ol>
          <p>
            <b>Performance cookies</b>
            <span>
              {' '}
              – These cookies collect information about how visitors use a
              website, for instance which pages visitors go to most often, and
              if they get error messages from web pages. These cookies don’t
              collect information that identifies a visitor. All information
              these cookies collect is anonymous and is only used to improve how
              a website works.
            </span>
          </p>
          <p>
            <span>We categorize the following as performance cookies:</span>
          </p>
          <ol>
            <li>
              <span>
                Referrer URL (internal page) – Used to store the URL of the
                previous page visited. Allows us to track how visitors navigate
                through our website.
              </span>
            </li>
            <li>
              <span>
                Referrer URL (external page, including if you click on links on
                ATC social media pages). Used to store the URL which refers a
                visitor to our website so we may understand what URLs are
                referring visitors to our website.
              </span>
            </li>
            <li>
              <span>
                URL history – Used to store the page visited by a user before
                that user submits a form. Also, used to display recently viewed
                articles to each visitor.
              </span>
            </li>
            <li>
              <span>
                Unregistered Visitor Cookie – A unique identifier given to each
                visitor to allow analysis on how unregistered visitors use our
                website.
              </span>
            </li>
            <li>
              <span>
                Session management cookies – These cookies allow us to follow
                the actions of a user during a browser session. A browser
                session starts when a user opens the browser window and finishes
                when they close their browser window. Our session management
                cookies are created temporarily. Once you close your browser,
                our session management cookies are deleted.
              </span>
            </li>
          </ol>
          <p>
            <b>Functionality cookies</b>
            <span>
              {' '}
              – These cookies allow a website to remember choices you make (such
              as your user name, language or the region you are in) and provide
              enhanced, more personal features. For instance, a website may be
              able to provide you with local information or news by storing in a
              cookie the region in which you are currently located. These
              cookies can also be used to remember changes you have made to text
              size, font and other parts of web pages that you can customize.
              They may also be used to provide services you have asked for such
              as watching a video or commenting on a blog. These cookies cannot
              track your browsing activity on other websites. They don’t gather
              any information about you that could be used for advertising or
              remembering where you’ve been on the internet outside our website.
            </span>
          </p>
          <p>
            <span>We categorize the following as functionality cookies:</span>
          </p>
          <ol>
            <li>
              <span>
                Recently viewed pages – Stores pages visited by the user on our
                website and displays them in right hand navigation for easy
                reference.
              </span>
            </li>
            <li>
              <span>
                Search history – Stores searches on our website conducted by the
                user and displays them for the user in the right hand navigation
                for easy reference.
              </span>
            </li>
            <li>
              <span>
                Registered Visitor Cookie – A unique identifier given to each
                registered user to our website, used to serve them content and
                offers based on their profiles. Also used for analysis and
                marketing purposes (See also: Strictly necessary cookies above
                and Use of cookies for marketing and analytics below).
              </span>
            </li>
          </ol>
          <p>
            <b>Targeting cookies</b>
            <span>
              {' '}
              – These cookies are used to: (1) deliver advertisements that are
              targeted to be relevant to you, (2) limit the number of times you
              see an advertisement, and (3) help measure the effectiveness of
              the advertising campaign. They are usually placed by advertising
              networks with the website operator’s permission. They remember
              that you have visited a website and this information is shared
              with other organizations such as advertisers. Quite often they
              will be linked to website functionality provided by the other
              organization.
            </span>
          </p>
          <p>
            <span>
              At ATC we do not have third party advertising on our website but
              these cookies may be used on third party websites and third
              parties may use them on our website as follows:
            </span>
          </p>
          <ol>
            <li>
              <span>
                Third party social media websites may log information about you,
                for example if you click an “Add This” or “Like” button for a
                social media website while on our website. We do not control
                such websites or their activities. You may be able to find
                information about social media websites on the websites
                themselves. We recommend you read the terms of use and privacy
                policy of such websites before using them.
              </span>
            </li>
            <li>
              <span>
                If you click on a ATC advertisement on a non-ATC website, a
                cookie may be used to log which website you are on, to ensure
                our advertisements are served effectively and to measure whether
                our advertisements are viewed.
              </span>
            </li>
            <li>
              <span>
                We partner with ShareThis on our website. ShareThis is a widget
                on the website that enables users to share content from the
                website with others through social media websites such as
                Facebook and Twitter. ShareThis includes cookies on the website
                which collect information on how users use the website and
                associate users with topics of interest, based on the content
                they share. This data will be used for analytics on the website
                (creating statistics as to what is most popular and how many
                people are sharing particular content) and to determine how to
                target advertising on other external websites. ShareThis may
                share its analytical data with ATC. ShareThis does not use
                personal identifiers of users (such as names and e-mail
                addresses) for these purposes and identification is solely by an
                anonymous identifier. For further information about ShareThis,
                the cookies it uses and how to opt out of ShareThis cookies,
                please refer to their website [
              </span>
              <a href="http://www.sharethis.com/privacy">
                <span>www.sharethis.com/privacy</span>
              </a>
              <span>].</span>
            </li>
            <li>
              <span>
                We use reputable third parties to gather and provide us with
                information about our website and advertising audiences and to
                deliver targeted advertisements on third party sites. These
                third parties only use anonymous identifiers and have no way of
                associating these identifiers with identifiable users.
              </span>
            </li>
          </ol>
          <p>
            <b>Use of cookies for marketing and analytics</b>
            <span>
              {' '}
              – We may use information collected from our cookies to identify
              user behavior and to serve content and offers based on your
              profile, and for the other purposes described below.
            </span>
          </p>
          <p>
            <span>
              Some of the cookies we use don’t collect information that
              identifies a visitor. For example –
            </span>
          </p>
          <ul>
            <li>
              <span>Performance cookies (see above)</span>
            </li>
            <li>
              <span>
                Targeting cookies (see above) where you are not a registered
                user
              </span>
            </li>
          </ul>
          <p>
            <span>
              In other cases we can associate cookie information (including
              information from cookies placed via our advertisements on third
              party sites) with an identifiable individual. For example –
            </span>
          </p>
          <ul>
            <li>
              <span>
                If a user is a registered user (see Registered Visitor Cookie
                above)
              </span>
            </li>
            <li>
              <span>
                If we send you a targeted email which includes web beacons,
                cookies or similar technologies we will know whether you open,
                read, or delete the message.
              </span>
            </li>
            <li>
              <span>
                When you click a link in a marketing e-mail you receive from
                ATC, we will also use a cookie to log what pages you view and
                what content you download from our websites, even if you are not
                registered at or signed into our site.
              </span>
            </li>
          </ul>
          <p>
            <b>Non-cookie tracking technologies</b>
            <span>
              {' '}
              – ATC also employs technologies that perform similar functions to
              cookies, but that may not respond to browser settings intended for
              use with cookies. These include personalized URLs (PURLs), web
              beacons, and other similar technologies.
            </span>
          </p>
          <h2>
            <b>MARKETING</b>
          </h2>
          <p>
            <span>
              ATC uses personal data of our clients, potential recruits, alumni
              and other business contacts to develop and strengthen our client,
              employee and business relationships, provide information about our
              company and services and to communicate about our services. In
              general, ATC is a business-to-business company, and does not
              typically market to consumers or the general public (other than to
              potential recruits and alumni). Rather, our marketing activities
              are targeted to relevant individuals we identify as decision
              makers at current or potential client companies. The bulk of the
              personal data we collect and use for marketing purposes relates to
              individual employees of our clients and other companies with which
              we have an existing business relationship. We may also obtain
              contact information from public sources, including content made
              public at social media websites, to make an initial contact with a
              relevant individual at a client or other company.
            </span>
          </p>
          <p>
            <b>Targeted E-mail</b>
            <span>
              . We send commercial e-mail to individuals at our client or other
              companies with whom we want to develop or maintain a business
              relationship. Our targeted e-mail messages typically include web
              beacons, cookies, and similar technologies that allow us to know
              whether you open, read, or delete the message, and links you may
              click. When you click a link in a marketing e-mail you receive
              from ATC, we will also use a cookie to log what pages you view and
              what content you download from our websites, even if you are not
              registered at or signed into our site.
            </span>
          </p>
          <p>
            <span>
              Targeted e-mails from ATC may include additional data privacy
              information, as required by applicable laws.
            </span>
          </p>
          <p>
            <span>
              ATC may opt to use customer relationship management (CRM) database
              technology to manage and track our marketing efforts. Such
              databases include personal data belonging to individuals at our
              client and other companies with whom we already have a business
              relationship or want to develop one. The personal data used for
              these purposes includes relevant business information, such as:
              contact data, publicly available information (e.g. board
              membership, published articles, press releases, your public posts
              on social media sites if relevant for business purpose), your
              responses to targeted e-mail (including web activity following
              links from our e-mails), website activity of registered users of
              our website, and other business information included by ATC
              professionals based on their personal interactions with you. If
              you wish to be excluded from our CRM databases, please use the
              contact us form.
            </span>
          </p>
          <p>
            <span>
              We may combine data from publicly available sources, and from our
              e-mail, website, and personal interactions with you. We combine
              this data to better understand your needs and the needs of your
              company, to assess the suitability of our service offerings for
              your needs, and to perform the other activities described
              throughout this privacy statement.
            </span>
          </p>
          <p>
            <b>SMS and Text messages</b>
            <span>
              . ATC and its representative may contact current or prospective clients
              through SMS and/or Text messaging platforms for business purposes and/or
              for important updates regarding our products, services and the recipient’s
              business relationship with us. We may use tracking methodologies built into
              the messaging platforms themselves to help us understand and improve the
              efficacy of such messages.
            </span>
          </p>
          <p>
            <b>Telephonic call</b>
            <span>
              . Representatives of ATC may contact current or prospective clients,
              potential recruits, alumni and other business contacts over a telephonic call
              to discuss current or future business with us, as part of the recruitment process
              and/or for marketing purposes. The information sought and collected through
              the call may be used to better understand the recipient’s business needs and
              requirements and will form part of a database that ATC will use solely for
              marketing and purposes. Information collected as part of any recruitment process
              will be used entirely to that effect.
            </span>
          </p>
          <p>
            <span>
              The contact information used for SMS and Text messages and/or telephonic calls is
              collected from recipients demonstrating express interest in being contacted by ATC.
            </span>
          </p>
          <p>
            <b>Opting out of all communication from ATC</b>
          </p>
          <p>
            <span>
              While we take utmost care to only reach recipients who might be interested in business or
              association with ATC, it might happen that in certain instances recipients might not be
              open to receiving said communication or would no longer be interested in being communicated
              about products and services they previously expressed interest in. ATC respects and strives
              to protect the privacy of the recipients of all its communication. Recipients of any
              communication from ATC can opt out of all future communication from ATC at any time. On
              receipt of such a request, ATC will stop all communication effective immediately and would
              no longer use any of the recipient’s contact information or personal data in its marketing efforts.
            </span>
          </p>
          <h2>
            <b>RECRUITING</b>
          </h2>
          <p>
            <span>
              If you use ATC’s online career resources, we collect personal data
              that you submit to the website and use it for recruiting-related
              purposes. We may also use Cookies and other tracking technology
              and the same technologies we use for Marketing (including Customer
              Relationship Management (CRM) Databases, Targeted E-mail &amp;
              Combining and Analyzing Personal Data) to provide individuals with
              a personalized online experience, to send relevant information
              about careers and opportunities at ATC, and to analyze the
              effectiveness of our recruitment efforts and resources.
            </span>
          </p>
        </div>
      </section>
      <SectionContact />
    </Layout>
  </>
);

PlatformPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default PlatformPage;
